export const FUEL_CACHE_TYPE = 'FUEL';
export const FUEL_STATSIG_CONFIG_NAME = 'fuel-service-worker-config-enabled';
export const FUEL_BROADCAST_CHANNEL = 'motive-fuel-sw-v-channel';
const FUEL_OVERVIEW_API = '/api/w3/fuel/overview';
const FUEL_TRENDS_API = '/api/w3/fuel/trends';

export const getTTL = (ttl: number | string): string => {
  return new Date(Date.now() + (ttl as number) * 60 * 60 * 1000).toISOString();
};

export const getFuelExpiryTimeFromApi = (requestUrl: string, response: any, ttl: string): string => {
  if (requestUrl.includes(FUEL_OVERVIEW_API)) {
    const lastUpdatedAtDate = new Date(response.summary.period_end_date);
    const increasedDate = new Date(lastUpdatedAtDate.setDate(lastUpdatedAtDate.getDate() + 7));
    const isoString = increasedDate.toISOString();
    return isoString;
  }
  else if (requestUrl.includes(FUEL_TRENDS_API)) {
    if (response.fleet_scores && response.fleet_scores[0]) {
      const lastUpdatedAtDate = new Date(response.fleet_scores[0].week_end_date);
      const increasedDate = new Date(lastUpdatedAtDate.setDate(lastUpdatedAtDate.getDate() + 7));
      const isoString = increasedDate.toISOString();
      return isoString;
    }
    return getTTL(ttl);
  }
};
